module.exports = __webpack_public_path__ + "media/travaux.9de5f23b.mp4";